import { createApi } from "@reduxjs/toolkit/query/react";
import { privateBaseQuery } from "@/api/base/private/privateBaseQuery";
import { ApiEnvelope } from "@/types/canonical";
import type { BackendUiLanguage } from "@/shared/i18n/languages";

const unwrap = <T>(res: T | ApiEnvelope<T>): T => {
  const maybe = res as ApiEnvelope<T>;
  return typeof maybe === "object" && maybe !== null && "entity" in maybe
    ? (maybe.entity as T)
    : (res as T);
};

export const languagesApi = createApi({
  reducerPath: "languagesApi",
  baseQuery: privateBaseQuery(),
  endpoints: (builder) => ({
    getSchoolLanguages: builder.query<BackendUiLanguage[], void>({
      query: () => ({
        url: "/languages.json",
        method: "GET",
      }),
      transformResponse: (
        res: ApiEnvelope<BackendUiLanguage[]> | BackendUiLanguage[]
      ) => unwrap<BackendUiLanguage[]>(res),
    }),

    getAllLanguages: builder.query<BackendUiLanguage[], void>({
      query: () => ({
        url: "/languages/all",
        method: "GET",
      }),
      transformResponse: (
        res: ApiEnvelope<BackendUiLanguage[]> | BackendUiLanguage[]
      ) => unwrap<BackendUiLanguage[]>(res),
    }),
  }),
});

export const {
  useGetSchoolLanguagesQuery,
  useGetAllLanguagesQuery,
} = languagesApi;
